import {
    GET_PHOTOS,
    GET_PHOTOS_SUCCESS,
    GET_PHOTOS_FAIL,
    GET_PHOTO_FAULTS,
    GET_PHOTO_FAULTS_SUCCESS,
    GET_PHOTO_FAULTS_FAIL,
    DELETE_PHOTO,
    DELETE_PHOTO_SUCCESS,
    DELETE_PHOTO_FAIL,
    SELECT_PHOTO,
    REMOVE_PHOTO_SELECTION,
} from '../types/photos';

export const getPhotos = (axiosInstance, projectId) => ({
    type: GET_PHOTOS,
    axiosInstance,
    projectId,
});

export const getPhotosSuccess = (photos) => ({
    type: GET_PHOTOS_SUCCESS,
    photos: photos,
});

export const getPhotosFail = (error) => ({
    type: GET_PHOTOS_FAIL,
    error,
});

export const getPhotoFaults = (axiosInstance, photoId) => ({
    type: GET_PHOTO_FAULTS,
    axiosInstance: axiosInstance,
    photoId: photoId,
});

export const getPhotoFaultsSuccess = (photoFaults) => ({
    type: GET_PHOTO_FAULTS_SUCCESS,
    photoFaults,
});

export const getPhotoFaultsFail = () => ({
    type: GET_PHOTO_FAULTS_FAIL,
});

export const deletePhoto = (axiosInstance, photoId) => ({
    type: DELETE_PHOTO,
    photoId,
    axiosInstance,
});

export const deletePhotoSuccess = (photoId) => ({
    type: DELETE_PHOTO_SUCCESS,
    photoId,
});

export const deletePhotoFails = (error) => ({
    type: DELETE_PHOTO_FAIL,
    error,
});

export const selectPhoto = (photoId) => ({
    type: SELECT_PHOTO,
    photoId,
});

export const removePhotoSelection = () => ({
    type: REMOVE_PHOTO_SELECTION
});


// WEBPACK FOOTER //
// ./src/actions/photos.jsx